import React from 'react'
import { Route } from 'react-router-dom'
import Moment from 'moment'

import SwipeablePerson from './SwipeablePerson'
import PhoneActionButtons from '../person/PhoneActionButtons'
import colors from '../../styles/colors'
import {
  PersonListItemWrapper,
  PersonListItemInfoTitle,
  PersonListItemInfoSub,
} from '../../styles/lists'
import {
  Badge,
} from '../../styles/badges'

const PersonListItem = ({person}) => (
  <Route render={({history}) => (
    <SwipeablePerson person={person} history={history}>
      <PersonListItemWrapper key={person.id}>
        <div>
          <PersonListItemInfoTitle>{person.name}</PersonListItemInfoTitle>
          {person.showAsReady && <br /> }
          {person.interval && <PersonListItemInfoSub>{person.intervalString}</PersonListItemInfoSub>}
          {person.showAsLate && <div style={{color: colors.red}}>last talk {Moment(person._lastTouchDate.toDate()).fromNow()}</div>}
        </div>
        <div>
          {person.showAsReady && <PhoneActionButtons person={person} /> }
          {person.showAsUpcoming && <Badge orange={person.showAsSnoozed}>{Moment(person.nextTouch).format('MMM Do')}</Badge>}
        </div>
      </PersonListItemWrapper>
    </SwipeablePerson>
  )} />
)

export default PersonListItem



// WEBPACK FOOTER //
// ./src/views/people/PersonListItem.js